import { Modal } from 'antd';
import { useHistory } from 'react-router-dom';
import useUpdateQueue from '@Hooks/mutation/useUpdateQueue';

const useUpdateQueueStatus = (queueId, shiftId) => {
  const history = useHistory();
  const { mutate, isLoading } = useUpdateQueue();

  const updateStatus = (statusId) => {
    const payload = { _method: 'PATCH', queue_status_id: statusId };
    mutate(
      { queueId, payload },
      {
        onSuccess: () => {
          Modal.success({
            title: 'Sukses!',
            content: 'Data Antrian Telah Berhasil Diubah!',
            onOk: () => history.push(`/queues/${shiftId}`),
          });
        },
        onError: () => {
          Modal.error({
            title: 'Gagal',
            content: 'Status Gagal Diperbarui',
          });
        },
      }
    );
  };

  return { updateStatus, isLoading };
};

export default useUpdateQueueStatus;
